import React from 'react';

interface QuickAnswerProps {
  children: React.ReactNode;
}

export function QuickAnswer({ children }: QuickAnswerProps) {
  return (
    <aside
      aria-label="Quick answer"
      className="mb-10 rounded-lg border-l-4 border-primary bg-muted/60 p-5 sm:p-6"
    >
      <div className="text-xs font-mono uppercase tracking-wider text-primary mb-2">
        Quick answer
      </div>
      <div className="text-base sm:text-lg text-foreground leading-relaxed">
        {children}
      </div>
    </aside>
  );
}
